import axios from 'axios';
import { API_BASE_URL } from '@/modules/shared/constants';
import type { GlobalSearchResponse } from './types';

/**
 * Portal-wide search. Despite the endpoint name, the backend matches many
 * fields (vehicle number, agent name, policy/order refs, ...) across all
 * document types when no `module`/`document_type` narrowing is sent.
 */
export const fetchGlobalSearch = async (term: string, signal?: AbortSignal): Promise<GlobalSearchResponse> => {
  const response = await axios.get<GlobalSearchResponse>(`${API_BASE_URL}/utils/vehicle-number-search`, {
    params: { vehicle_number: term },
    signal,
  });
  return response.data;
};
